//------------------------------------------------------------------------------
// name: system.ts
// author: mudas
// created: 2025/12/06
//------------------------------------------------------------------------------

import { FastApiAxiosInstance } from 'common/service/axiosInstances';
import { Identity } from 'common/types';

export interface SystemCountry extends Identity {}

export interface SystemProvince extends SystemCountry {
  countryId: number;
}

export interface SystemCity extends SystemCountry {
  provinceId: number;
}

export const getSystemCountry = () => {
  return FastApiAxiosInstance.get<SystemCountry[]>('/api/v1/system/country');
};

export const getSystemProvince = (countryId?: number) => {
  return FastApiAxiosInstance.get<SystemProvince[]>('/api/v1/system/province', {
    params: {
      countryId,
    },
  });
};

export const getSystemCity = (provinceId: number) => {
  return FastApiAxiosInstance.get<SystemCity[]>('/api/v1/system/city', {
    params: {
      provinceId,
    },
  });
};
